<template>
  <!-- eslint-disable -->
  <v-dialog v-model="show"  persistent width="250">
    <v-card>
      <v-card-title>
        <h3>Calamity Call Status</h3>
      </v-card-title>
      <v-card-text style="padding: 0 25px 10px 25px;">
        <div style="padding: 10px 0;">
          <h2>{{calamity.ClientName}}</h2>
          <v-container fluid grid-list-lg style="padding-bottom: 0;">
            <div style="text-align: center;"><strong>Calls Scheduled:</strong> {{statusData.totalCalls}}</div>
            <div style="text-align: center;"><strong>Calls Sent:</strong> {{statusData.callsSent}}</div>
            <div style="text-align: center;"><strong>Is Canceled:</strong> {{statusData.isCanceled}}</div>
            <div style="text-align: center;">
              <v-btn color="primary" v-if="!statusData.isCanceled" :disabled="canceling" depressed @click.stop="cancel()">Cancel Calls</v-btn>
            </div>
          </v-container>  
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" :disabled="canceling" flat @click.stop="show=false">Close</v-btn>
        <v-progress-circular v-show="canceling" indeterminate color="primary"></v-progress-circular>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- eslint-enable -->
</template>

<script>
import { mapGetters } from "vuex";
import { CALAMITY_NAMESPACE } from "./store/calamityStore";

export default {
  name: "CalamityCalls",
  data() {
    return {
      statusData: {},
      calamityIsRef: {},
      calamityMinContent: {},
      callsPerHour: 1,
      overClientLimitAcknowledge: false,
      selected: [],
      show: false,
      canceling: false,
      calamity: {}
    };
  },
  computed: {
    ...mapGetters(CALAMITY_NAMESPACE, [])
  },
  created: /* istanbul ignore next */ function() {
    this.$parent.$on("calamityCallsStatus", this.showDialog);
  },
  methods: {
    showDialog(payload) {
      return this.$store
        .dispatch(`${CALAMITY_NAMESPACE}/getCalamityCallsStatus`, payload)
        .then(res => {
          this.show = true;
          this.statusData = res;
        });
    },
    cancel() {
      this.canceling = true;
      var payload = {
        InstanceId: this.statusData.instanceId,
        CalamityId: this.statusData.calamityId
      };
      return this.$store
        .dispatch(`${CALAMITY_NAMESPACE}/cancelCalamityCalls`, payload)
        .then(res => {
          this.show = false;
          this.canceling = false;
        })
        .catch(
          /* istanbul ignore next */ () => {
            this.canceling = false;
          }
        );
    }
  }
};
</script>
